/**
 * Ops health hooks (A.4) — delivery-pipeline status for the supervisor.
 */
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import type { OpsHealth, OpsRetryResponse } from '@vari-crew/schemas';
import { apiCall } from '@/lib/api';

export function useOpsHealth(enabled = true) {
  return useQuery<OpsHealth>({
    queryKey: ['ops', 'health'],
    enabled,
    refetchInterval: 60_000,
    queryFn: () => apiCall<OpsHealth>('/ops/health'),
  });
}

export function useRetryOutbox() {
  const qc = useQueryClient();
  return useMutation<OpsRetryResponse, Error, void>({
    mutationFn: () => apiCall<OpsRetryResponse>('/ops/outbox/retry', { method: 'POST' }),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['ops', 'health'] }),
  });
}
